import { render, staticRenderFns } from "./GroupTemplatesAssignment.vue?vue&type=template&id=ec110892&scoped=true"
import script from "./GroupTemplatesAssignment.vue?vue&type=script&lang=js"
export * from "./GroupTemplatesAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec110892",
  null
  
)

export default component.exports